import React, { useState, useEffect } from "react";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDocument,
  checkEmpty,
  checkString,
  checkStringNew,
  decryptData,
  mobileNumber,
  noNomineeFound,
  splitDate,
  splitDateSlash,
} from "../../CommonMethhods/CommonMethods";
import { Constants } from "../../CommonMethhods/Constants";
import KycSupport from "../ClientDashboard/Details/Kyc/KycSupport";
import { partner_Api } from "../../Configuration/Partner_URL";
import { DASHBOARD_CLIENT_OVERVIEW } from "../../Configuration/API_URL";
import { Form } from "react-bootstrap";
import { axiosSsoJsonReserv1, axiosSsoText } from "../../CommonMethhods/axiosPartnerInterceptor";

export default function PartnerDetailsKyc(props) {
  const PartnerClientCode = localStorage.getItem("ClientId2");
  const [documentList, setDocumentList] = useState();
  // const [viewDocList, setViewDocList] = useState([]);
  // const [loader, setLoader] = useState(true);
  const storeToken = localStorage.getItem("ssoToken");
  const [selectedBank, setSelectedBank] = useState(null);
  const [bankList, setBankList] = useState([]);
  let kycBasicDetails = props.kycBasicDetails;

  console.log(kycBasicDetails, "kycBasicDetails");
  
  const viewDocuments = async (definition_type) => {
    try {
      const viewDocumentsList = await axiosSsoText.get(
        `${partner_Api.Get_DownloadDocuments_Partner}?onl_id=${PartnerClientCode}&definition=${definition_type}`,
      );
      const response = decryptData(viewDocumentsList?.data);
      let decryptedResponse = JSON.parse(response);
      window.open(
        decryptedResponse?.data?.url,
        "_blank",
        "noopener,noreferrer"
      );

      // setViewDocList(response);
    } catch (error) {
      console.log(error);
    }
  };

  const kycUploadDocuments = async (clientCode) => {
    let payloadValue = { clientCode: clientCode, pan: "" };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDocumentsList = await axiosSsoJsonReserv1.post(
        DASHBOARD_CLIENT_OVERVIEW.GetAllDocuments_URL,
        `"${encPayload}"`,
      );
      const response = ApiResDecrypt(getDocumentsList?.data);
      // let decryptedResponse = JSON.parse(response);

      if (typeof response?.data == "object") {
        setDocumentList(response?.data);
      }
      // setLoader(false);
    } catch (error) {
      console.log(error);
      // setLoader(false);
    }
  };
  useEffect(() => {
    if (PartnerClientCode) {
      let clientCode = PartnerClientCode;
      kycUploadDocuments(clientCode);
    }
  }, []);

  useEffect(() => {
    if (kycBasicDetails?.bankdtls?.length) {
      const primaryBank = kycBasicDetails?.bankdtls.find(
        (bank) => bank?.isPrimary === true
      );
      setSelectedBank(primaryBank);
      setBankList(kycBasicDetails?.bankdtls);
    }
  }, [kycBasicDetails]);

  const handleBankChange = (event) => {
    const selectedBankId = event.target.value;
    const bank = bankList.find(
      (bank) => bank?.bankId === parseInt(selectedBankId)
    );
    setSelectedBank(bank);
  };

  return (
    <>
      {/* <!-- KYC tabs --> 

      {/* <!-- Support/ Comments /Active/Inactive Session --> */}
      <div className="row gy-3  bottom-25">
        <KycSupport />
      </div>

      {/* <!-- basic Details --> */}
      <div className="card-box bottom-25">
        <div className="card-title">
          <h2>{Constants.Basic_Details}</h2>
        </div>
        <div className="table-wrapper">
          <div className="table-wrapper">
            <table className="table kyc-table">
              <tbody>
                <tr>
                  <td scope="col">{Constants.Full_Name}</td>
                  <td scope="col" className="color-green">
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString(kycBasicDetails?.name)}
                  </td>

                  <td>{Constants.Client_ID}</td>
                  <td>
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString(kycBasicDetails?.clientCode)}
                  </td>

                  <td>{Constants.PAN}</td>
                  <td>
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString && mobileNumber(kycBasicDetails?.pan)}
                  </td>

                  {/* <td scope="col">{Constants.NAME_AS_IT_SITE}</td>
                  <td className="color-green text-uppercase">
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString(kycBasicDetails?.lName)}
                  </td> */}
                  
                </tr>
                <tr>
                  <td>{Constants.FATHER_NAME}</td>
                  <td>
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString(kycBasicDetails?.mname)}
                  </td>
                  <td scope="col">{Constants.gender}</td>
                  <td scope="col">
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString(kycBasicDetails?.gender)}
                  </td>
                  {/* <td>{Constants.Mother_Name}</td>
                  <td>
                    {kycBasicDetails === undefined || null
                      ? "NA"
                      : kycBasicDetails?.mName === undefined || null || " "
                      ? "NA"
                      : kycBasicDetails?.mName}
                  </td> */}
                  <td></td>
                  <td></td>
                  
                </tr>
                <tr>
                  <td>{Constants.MARITAL_STATUS}</td>
                  <td>
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString(kycBasicDetails?.maritalStatus)}
                  </td>
                  <td>{Constants.DATE_OF_BIRTH}</td>
                  <td>
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString(splitDateSlash(kycBasicDetails?.dob))}
                  </td>
                  <td></td>
                  <td></td>
               
                </tr>
                {/* <tr>
                  <td>{Constants.NOMINEE}</td>
                  <td>
                    {checkEmpty(kycBasicDetails)
                      ? "NA"
                      : checkString(kycBasicDetails.isNominee)}
                  </td> */}
                {/* <td>AADHAR NUMBER</td>
                  <td>NA</td> */}

                {/* <td className="blank-column" colSpan="4"></td>
                </tr> */}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* <!-- Address Details --> */}
      <div className="card-box bottom-25 kyc-address">
        <div className="card-title">
          <h2>{Constants.Address_Details}</h2>
        </div>
        <div className="table-wrapper">
          <table className="table kyc-table">
            <tbody>
              <tr>
                <td>{Constants.ADDRESS_LINE_1}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails?.addressdtls?.address1)}
                </td>
                <td>{Constants.CITY}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails?.addressdtls?.city)}
                </td>
              </tr>
              <tr>
                <td>{Constants.ADDRESS_LINE_2}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails?.addressdtls?.address2)}
                </td>
                <td>{Constants.STATE}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails?.addressdtls?.state)}
                </td>
              </tr>
              <tr>
                <td>{Constants.ADDRESS_SAME}</td>
                <td>NA</td>
                <td>{Constants.ZIP_CODE}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails?.addressdtls?.zip)}
                </td>
              </tr>
              <tr>
                <td>{Constants.CORRESPONDENCE_ADD_1}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails?.addressdtls?.address1)}
                </td>
                <td>{Constants.CORRESPONDENCE_CITY}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails?.addressdtls?.city)}
                </td>
              </tr>
              <tr>
                <td>{Constants.CORRESPONDENCE_ADDRESS_2}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails?.addressdtls?.address2)}
                </td>
                <td>{Constants.CORRESPONDENCE_STATE}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails?.addressdtls?.state)}
                </td>
              </tr>
              <tr>
                <td className="blank-column"></td>
                <td className="blank-column"></td>
                <td>{Constants.CORRESPONDENCE_ZIP}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails?.addressdtls?.zip)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

   
          {/* <div className="card-box bottom-25 kyc-address">
            <div className="card-title">
              <h2>{Constants.Bank_Details}</h2>
            </div>
            <div className="table-wrapper">
              <table className="table kyc-table">
                <tbody>
                  <tr>
                    <td>{Constants.BANK_NAME}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails?.bank_name)}
                    </td>
                    <td>{Constants.BRANCH}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails?.bank_branch_name)}
                    </td>
                  </tr>
                  
                  <tr>
                    <td>{Constants.BANK_ZIPCODE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails?.bankzipcode)}
                    </td>
                    <td>{Constants.ACCOUNT_NUMBER}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(
                            mobileNumber(kycBasicDetails?.account_no)
                          )}
                    </td>
                  </tr>
                  
                  <tr>
                    <td>{Constants.IFSC_CODE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails?.ifsc)}
                    </td>
                    <td>{Constants.MICR_NUMBER}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails?.micr_code)}
                    </td>
                  </tr>
                  
                  <tr>
                    <td>{Constants.ACCOUNT_TYPE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails?.account_type)}
                    </td>
                    <td>{Constants.CANCELLED_CHEQUE_FILE}</td>
                    <td>NA</td>
                  </tr>
                  
                  <tr>
                    <td>{Constants.PENNY_BENEFICIARY_NAME}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails?.pennybeneficiaryname)}
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div> */}

<div className="col-md-12 bank-details">
          <div className="card-box">
            <div className="wrap-bank-header">
              <div className="card-title">
                <h2>{Constants.Bank_Details}</h2>
              </div>

              {kycBasicDetails?.bankdtls?.length ? (
                <div className="dropdown-filter bank-select">
                  <Form.Select
                    size="lg"
                    aria-label="Default select example"
                    value={selectedBank ? selectedBank?.bankId : ""}
                    onChange={handleBankChange}
                  >
                    {kycBasicDetails?.bankdtls?.length ?
                      kycBasicDetails?.bankdtls.map((item) => {
                        const bankName = item?.bankName.split(" ")[0];
                        const accNumber = mobileNumber(item?.acNo);
                        let lastSix = accNumber.slice(-6);
                        let nameAccount =
                          bankName +
                          " - " +
                          lastSix +
                          (item?.isPrimary == true
                            ? " (Primary Account) "
                            : "");

                        return (
                          <option key={item?.bankId} value={item?.bankId}>
                            {nameAccount}
                          </option>
                        );
                      }): null}
                  </Form.Select>
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="table-wrapper">
              <table className="table kyc-table">
                <tbody>
                  <tr>
                    <td>{Constants.BANK_NAME}</td>
                    <td>
                      {checkEmpty(selectedBank)
                        ? "-"
                        : checkStringNew(selectedBank?.bankName)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.BRANCH}</td>
                    <td>
                      {checkEmpty(selectedBank)
                        ? "-"
                        : checkStringNew(selectedBank?.branch)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.ACCOUNT_NUMBER}</td>
                    <td>
                      {checkEmpty(selectedBank)
                        ? "-"
                        : checkStringNew(mobileNumber(selectedBank?.acNo))}
                    </td>
                  </tr>

                  <tr>
                    <td>{Constants.IFSC_CODE}</td>
                    <td>
                      {checkEmpty(selectedBank)
                        ? "-"
                        : checkStringNew(selectedBank?.ifsc)}
                    </td>
                  </tr>
                  {/* <tr>
                    <td>{Constants.MICR_NUMBER}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails.bankdtls.micr_No)}
                    </td>
                  </tr> */}
                  <tr>
                    <td>{Constants.ACCOUNT_TYPE}</td>
                    <td>
                      {checkEmpty(selectedBank)
                        ? "-"
                        : checkStringNew(selectedBank?.acType)}
                    </td>
                  </tr>
                  {/* <tr>
                    <td>{Constants.CANCELLED_CHEQUE_FILE}</td>
                    <td>
                      {checkEmpty(selectedBank)
                        ? "-"
                        : checkStringNew(selectedBank?.cancelledChequeFile)}
                    </td>
                  </tr> */}
                  <tr>
                    <td>{Constants.PENNY_BENEFICIARY_NAME}</td>
                    <td>
                      {checkEmpty(selectedBank)
                        ? "-"
                        : checkStringNew(selectedBank?.pennyBenName)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>






        {/* </div> */}

        {/* <!-- Fatca --> */}

        {/* <div className="col-md-6 Fatca">
          <div className="card-box">
            <div className="card-title">
              <h2>{Constants.Fatca}</h2>
            </div>
            <div className="table-wrapper">
              <table className="table kyc-table">
                <tbody>
                  <tr>
                    <td>{Constants.BIRTH_PLACE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails?.birth_country)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.POLITICAL_RELATION}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails?.political_relation)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.ITAX_COUNTRY}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails?.tax_country)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.BIRTH_COUNTRY}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails?.birth_country)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.INCOME_SLAB}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails?.income_slab)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.OCCUPATION_CODE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails?.occupation_code)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.TAX_ID_NUMBER}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails?.tax_id_number)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div> */}
      {/* </div> */}

      {/* <!-- user upload documents --> */}

      {/* <div className="card-box bottom-25">
        <div className="card-title">
          <h2>{Constants.User_Uploaded_Documents}</h2>
        </div>
        <div className="table-wrapper">
          <table className="table kyc-table">
            <tbody>
              <tr>
                <td>{Constants.ADDRESS_PROOF_FRONT}</td>
                <td>
                  {checkEmpty(documentList) ? (
                    <FileIconGray />
                  ) : (
                    checkDocument(
                      viewDocuments,
                      documentList?.useruploadeddocuments?.addressprooffront
                    )
                  )}
                </td>
                <td>{Constants.ADDRESS_PROOF_REAR}</td>
                <td>
                  {checkEmpty(documentList) ? (
                    <FileIconGray />
                  ) : (
                    checkDocument(
                      viewDocuments,
                      documentList?.useruploadeddocuments?.AddressProofrear
                    )
                  )}
                </td>
              </tr>
              <tr>
                <td>{Constants.ADDRESS_PROOF_TYPE}</td>
                <td>
                  {checkEmpty(documentList)
                    ? "NA"
                    : checkString(
                        documentList?.useruploadeddocuments?.AddressProoftype
                      )}
                </td>
                <td>{Constants.PAN_CARD_FILE}</td>
                <td>
                  {checkEmpty(documentList) ? (
                    <FileIconGray />
                  ) : (
                    checkDocument(
                      viewDocuments,
                      documentList?.useruploadeddocuments?.pancardfile
                    )
                  )}
                </td>
              </tr>
              <tr>
                <td>{Constants.INV_PHOTO_FILE}</td>
                <td className="table-icon">
                  {checkEmpty(documentList) ? (
                    <FileIconGray />
                  ) : (
                    checkDocument(
                      viewDocuments,
                      documentList?.useruploadeddocuments?.invphotofile
                    )
                  )}
                </td>
                <td>{Constants.GEO_LOCATION}</td>
                <td>
                  {checkEmpty(documentList)
                    ? "NA"
                    : checkString(
                        documentList?.useruploadeddocuments?.invphotogeolocation
                      )}
                </td>
              </tr>
              <tr>
                <td>{Constants.INV_SIGN_FILE}</td>
                <td className="table-icon">
                  {checkEmpty(documentList) ? (
                    <FileIconGray />
                  ) : (
                    checkDocument(
                      viewDocuments,
                      documentList?.useruploadeddocuments?.invsignfile
                    )
                  )}
                </td>
                <td>{Constants.INV_SIGN_FILE_FORMAT}</td>
                <td>
                  {checkEmpty(documentList)
                    ? "NA"
                    : checkString(
                        documentList?.useruploadeddocuments?.invphotofileformat
                      )}
                </td>
              </tr>
              <tr>
                <td>{Constants.INCOME_PROOF_FILE}</td>
                <td>
                  {checkEmpty(documentList) ? (
                    <FileIconGray />
                  ) : (
                    checkDocument(
                      viewDocuments,
                      documentList?.useruploadeddocuments?.incomeprooffile
                    )
                  )}
                </td>

                <td>{Constants.INCOME_PROOF_TYPE}</td>
                <td>
                  {checkEmpty(documentList)
                    ? "NA"
                    : checkString(
                        documentList?.useruploadeddocuments?.incomeprooftype
                      )}
                </td>
              </tr>
              <tr>
                <td>{Constants.POA_FILE}</td>
                <td className="table-icon">
                  {checkEmpty(documentList) ? (
                    <FileIconGray />
                  ) : (
                    checkDocument(
                      viewDocuments,
                      documentList?.useruploadeddocuments?.poafile
                    )
                  )}
                </td>
                <td>{Constants.CHEQUE_FILE}</td>
                <td>
                  {checkEmpty(documentList) ? (
                    <FileIconGray />
                  ) : (
                    checkDocument(
                      viewDocuments,
                      documentList?.useruploadeddocuments?.chequefile
                    )
                  )}
                </td>
              </tr>
              <tr>
                <td>{Constants.IDENTIFIER_NUMBER}</td>
                <td>
                  {checkEmpty(documentList)
                    ? "NA"
                    : checkString(
                        documentList?.useruploadeddocuments?.identifiernumber
                      )}
                </td>
                <td>{Constants.EXPIRY_DATE}</td>
                <td>
                  {checkEmpty(documentList)
                    ? "NA"
                    : checkString(
                        documentList?.useruploadeddocuments?.expirydate
                      )}
                </td>
              </tr>
              <tr>
                <td scope="col">{Constants.IPV_FILE}</td>
                <td>
                  {checkEmpty(documentList) ? (
                    <FileIconGray />
                  ) : (
                    checkDocument(
                      viewDocuments,
                      documentList?.useruploadeddocuments?.ipvfile
                    )
                  )}
                </td>
                <td className="blank-column" colSpan="2"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> */}

      {/* <!-- income and ipv details --> */}
      {/* <div className="row bottom-25">
        <div className="col-md-6 income-details">
          <div className="card-box">
            <div className="card-title">
              <h2>{Constants.Income_Details}</h2>
            </div>
            <div className="table-wrapper">
              <table className="table kyc-table">
                <tbody>
                  <tr>
                    <td>{Constants.INCOME_PROOF_TYPE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(
                            kycBasicDetails?.incomeDetails?.income_proof_type
                          )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.TAX_COUNTRY}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails?.tax_country)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.EXPERIENCE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(
                            kycBasicDetails?.incomeDetails?.Experience
                          )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.INCOME_DATE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(
                            kycBasicDetails?.incomeDetails?.incomeDate
                          )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.INCOME_SLAB}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails?.income_range)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.INCOME_TYPE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(
                            kycBasicDetails?.incomeDetails?.incomeType
                          )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.OCCUPATION}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails?.occupation)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.POLITICS}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(
                            kycBasicDetails?.incomeDetails?.isPolitical
                          )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.QUALIFICATION}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(
                            kycBasicDetails?.incomeDetails?.qualification
                          )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.INCOME_PROOF_FILE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "NA"
                        : checkString(kycBasicDetails?.incomeDetails?.document)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="col-md-6 ipv-details">
          <div className="card-box">
            <div className="card-title">
              <h2>{Constants.IPV_Details}</h2>
            </div>
            <div className="table-wrapper">
              <table className="table kyc-table">
                <tbody>
                  <tr>
                    <td>{Constants.IPV_NAME}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "Not Available"
                        : checkString(kycBasicDetails?.ipvDetail?.ipvName)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.IPV_EMPLOYEE_CODE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "Not Available"
                        : checkString(kycBasicDetails?.ipvDetail?.ipvEmpCode)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.IPV_OTP}</td>
                    <td>NA</td>
                  </tr>
                  <tr>
                    <td>{Constants.IPV_FILE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "Not Available"
                        : checkString(kycBasicDetails?.ipvDetail?.ipvFiles)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.IPV_FACEMATCH}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "Not Available"
                        : checkString(kycBasicDetails?.ipvDetail?.ipvFaceMatch)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.IPV_LOCATION}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "Not Available"
                        : checkString(kycBasicDetails?.ipvDetail?.ipvLocation)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.CREATED_DATE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "Not Available"
                        : checkString(kycBasicDetails?.ipvDetail?.create_date)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.MODIFIED_DATE}</td>
                    <td>
                      {checkEmpty(kycBasicDetails)
                        ? "Not Available"
                        : checkString(splitDate(kycBasicDetails?.modify_date))}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div> */}

      {/* <!-- forms and backoffice uploads --> */}
      {/* <div className="row bottom-25">
        <div className="col-md-6 forms-details">
          <div className="card-box">
            <div className="card-title">
              <h2>{Constants.Forms}</h2>
            </div>
            <div className="table-wrapper">
              <table className="table kyc-table">
                <tbody>
                  <tr>
                    <td>{Constants.AOF_FILE}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList?.forms?.aoffile
                        )
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.CKYC} </td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(viewDocuments, documentList?.forms?.ckyc)
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.CLIENT_REGISTRATION_FILE}</td>
                    <td className="table-icon">
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList?.forms?.clientregistrationfile
                        )
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.COMMODITY_REGISTRATION_FILE}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList?.forms?.commodityregistrationfile
                        )
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.EQUITY_CODE}</td>
                    <td>
                      {checkEmpty(documentList)
                        ? "NA"
                        : checkString(documentList?.forms?.equitycode)}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.COMMODITY_CODE}</td>
                    <td>
                      {checkEmpty(documentList)
                        ? "NA"
                        : checkString(documentList?.forms?.commoditycode)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="col-md-6 backoffice-uploads">
          <div className="card-box">
            <div className="card-title">
              <h2>{Constants.Backoffice_Uploads}</h2>
            </div>
            <div className="table-wrapper">
              <table className="table kyc-table">
                <tbody>
                  <tr>
                    <td>{Constants.KRA_PAGE_FILE}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList?.backofficeuploads?.krapagefile
                        )
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.KRA_ADDRESS_PROOF_FILE}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList?.backofficeuploads?.kraaddressprooffile
                        )
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.KRA_PAN_FILE}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList?.backofficeuploads?.krapanfile
                        )
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.BO_INCOME_FILE}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList?.backofficeuploads?.boincomefile
                        )
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.PAN_IT_FILE}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList?.backofficeuploads?.panitfile
                        )
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.POA_FILE}</td>
                    <td> NA</td>
                  </tr>
                  <tr>
                    <td>{Constants.EXTRA_DOCUMENT_FILE}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList?.backofficeuploads?.extradocumentfile
                        )
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div> */}

      {/* <!-- aadhaar and nominee details section --> */}
      {/* <div className="row bottom-25">
        <div className="col-md-6 aadhaar-details">
          <div className="card-box">
            <div className="card-title">
              <h2>{Constants.Aadhaar_Documents}</h2>
            </div>
            <div className="table-wrapper">
              <table className="table kyc-table">
                <tbody>
                  <tr>
                    <td>{Constants.Aadhaar_Documents}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList?.aadhardocuments?.aadharfile
                        )
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{Constants.AADHAAR_PHOTO}</td>
                    <td>
                      {checkEmpty(documentList) ? (
                        <FileIconGray />
                      ) : (
                        checkDocument(
                          viewDocuments,
                          documentList?.aadhardocuments?.aadharphoto
                        )
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="col-md-6 nominee-details">
          <div className="card-box">
            <div className="card-title mb-0">
              <h2>{Constants.Nominee_Details}</h2>
            </div>
            <div className="table-wrapper">
              <table className="table kyc-table">
                <tbody>
                  {checkEmpty(kycBasicDetails) ? (
                    <tr className="nominee-noData">
                      <td className="border-bottom-none">{noNomineeFound()}</td>
                    </tr>
                  ) 
                  (kycBasicDetails?.nominee_first_name?.length > 0 &&
                      kycBasicDetails?.nominee_last_name?.length > 0) ||
                    kycBasicDetails?.nominee_relation?.length > 0 ? (
                    <>
                      <tr className="d-flex flex-column">
                        {kycBasicDetails?.nominee_first_name?.length > 0 &&
                        kycBasicDetails?.nominee_last_name?.length > 0 ? (
                          <div className="d-flex justify-content-between w-75">
                            <td className="p-3">NAME</td>
                            <td className="text-start p-3">
                              {checkEmpty(
                                kycBasicDetails?.nominee_first_name +
                                  " " +
                                  kycBasicDetails?.nominee_last_name
                              )}
                            </td>
                          </div>
                        ) : (
                          ""
                        )}
                        {kycBasicDetails?.nominee_relation?.length > 0 ? (
                          <div className="d-flex justify-content-between w-75">
                            <td className="p-3">RELATION</td>
                            <td className="text-start p-3">
                              {checkEmpty(kycBasicDetails?.nominee_relation)}
                            </td>
                          </div>
                        ) : (
                          ""
                        )}
                      </tr>
                    </>
                  ) : (
                    <tr className="nominee-noData">
                      <td className="border-bottom-none">{noNomineeFound()}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div> */}

      {/* <!-- Others Details --> */}
      {/* <div className="card-box bottom-25 other-details">
        <div className="card-title">
          <h2>{Constants.Others}</h2>
        </div>
        <div className="table-wrapper">
          <table className="table kyc-table">
            <tbody>
              <tr>
                <td>{Constants.ONBOARD_STATUS}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails?.onboarded_status)}
                </td>
                <td>{Constants.AUTH_ONBOARD_STATUS}</td>
                <td>NA</td>
              </tr>
              <tr>
                <td>{Constants.APPROVAL_STATUS}</td>
                <td>NA</td>
                <td>{Constants.ESIGN_STATUS}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails?.esign_status)}
                </td>
              </tr>
              <tr>
                <td>{Constants.EKYC_SUBMITTED_STATUS}</td>
                <td>NA</td>
                <td>{Constants.ESIGN_CONSENT}</td>
                <td>NA</td>
              </tr>
              <tr>
                <td>{Constants.ESIGN_CONSENT_TS}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(splitDate(kycBasicDetails?.esign_consent_ts))}
                </td>
                <td>{Constants.IP_ADDRESS}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails?.ip_address)}
                </td>
              </tr>
              <tr>
                <td>{Constants.DEVICE_ID}</td>
                <td>NA</td>
                <td>{Constants.KYC_VERIFIED}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails?.kyc_verified)}
                </td>
              </tr>
              <tr>
                <td>{Constants.AADHAAR_VERIFIED}</td>
                <td>NA</td>
                <td>CREATED DATE</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(splitDate(kycBasicDetails?.create_date))}
                </td>
              </tr>
              <tr>
                <td>ONBOARDED DATE</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(splitDate(kycBasicDetails?.onboarded_at))}
                </td>
                <td>UPDATED DATE</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(splitDate(kycBasicDetails?.utm_update_date))}
                </td>
              </tr>
              <tr>
                <td>{Constants.UPDATED_BY}</td>
                <td>NA</td>
                <td>{Constants.Source}</td>
                <td>
                  {checkEmpty(kycBasicDetails)
                    ? "NA"
                    : checkString(kycBasicDetails?.source)}
                </td>
              </tr>
              <tr>
                <td>{Constants.NRI}</td>
                <td>NA</td>
                <td>{Constants.KRA_AGENT}</td>
                <td>NA</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> */}

      {/* <!-- KYC tabs end--> */}
    </>
  );
}
